import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, useParams } from 'react-router-dom';
// import './index.css';
import App from './App';
import Reassess from './Reassess';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
      <Routes>
        <Route path="/user/:id/:mboSiteId" element={<App />} />
        <Route path="/assess/:id/:mboSiteId" element={<Reassess />} />
        {/* You can add more routes here */}
      </Routes>
    </Router>
);
